module.exports = __webpack_public_path__ + "static/media/pentagram_inside_outside_2.7157f790.png";